import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div
          className={`flex items-center justify-between transition-all duration-300 ${
            isScrolled ? 'py-4' : 'py-6'
          }`}
        >
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="text-xl md:text-2xl font-bold text-brand-black hover:text-brand-orange transition-colors duration-300"
          >
            The WillisTRAINING Method™
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-brand-black hover:text-brand-orange font-medium transition-colors duration-300"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-brand-black hover:text-brand-orange font-medium transition-colors duration-300"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-brand-black hover:text-brand-orange font-medium transition-colors duration-300"
            >
              Results
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-brand-orange hover:bg-brand-orange-hover text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
            >
              Book Now
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-brand-black hover:text-brand-orange transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('about')}
              className="text-brand-black hover:text-brand-orange font-medium text-left transition-colors"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-brand-black hover:text-brand-orange font-medium text-left transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-brand-black hover:text-brand-orange font-medium text-left transition-colors"
            >
              Results
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-brand-orange hover:bg-brand-orange-hover text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 text-center"
            >
              Book Now
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;